<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
<!-- eslint-disable @angular-eslint/template/eqeqeq -->
<ng-container *ngIf="rideOpsUi.isV2Active$ | async; else v1Pin">
	<div id="pin-input" class="pin-input-v2">
		<div class="pin-container">
			<div class="pin-placeholder">
				<span class="pin-dot" [class.pin-dot--filled]="pin.length >= 1"></span>
				<span class="pin-dot" [class.pin-dot--filled]="pin.length >= 2"></span>
				<span class="pin-dot" [class.pin-dot--filled]="pin.length >= 3"></span>
				<span class="pin-dot" [class.pin-dot--filled]="pin.length >= 4"></span>
			</div>
		</div>

		<div class="numpad">
			<div class="number-row">
				<button type="button" class="number field" (click)="add(1)">1</button>
				<button type="button" class="number field" (click)="add(2)">2</button>
				<button type="button" class="number field" (click)="add(3)">3</button>
			</div>
			<div class="number-row">
				<button type="button" class="number field" (click)="add(4)">4</button>
				<button type="button" class="number field" (click)="add(5)">5</button>
				<button type="button" class="number field" (click)="add(6)">6</button>
			</div>
			<div class="number-row">
				<button type="button" class="number field" (click)="add(7)">7</button>
				<button type="button" class="number field" (click)="add(8)">8</button>
				<button type="button" class="number field" (click)="add(9)">9</button>
			</div>
			<div class="number-row">
				<button
					type="button"
					class="text field"
					(click)="clear()"
					[disabled]="pin.length <= 0"
					[attr.aria-label]="'OPERATOR_LOGIN__CLEAR' | transloco"
				>
					<span class="material-symbols-outlined material-symbols-outlined--size-24" aria-hidden="true">
						close
					</span>
				</button>
				<button type="button" class="number field" (click)="add(0)">0</button>
				<button
					type="button"
					class="text field"
					(click)="delete()"
					[disabled]="pin.length <= 0"
					[attr.aria-label]="'OPERATOR_LOGIN__DELETE' | transloco"
				>
					<span class="material-symbols-outlined material-symbols-outlined--size-24" aria-hidden="true">
						backspace
					</span>
				</button>
			</div>
		</div>
	</div>
</ng-container>

<ng-template #v1Pin>
	<div id="pin-input">
		<div class="pin-container">
			<div class="pin-placeholder">
				<ion-icon name="ellipse-outline" *ngIf="pin.length == 0"></ion-icon>
				<ion-icon name="ellipse" *ngIf="pin.length >= 1"></ion-icon>
				<ion-icon name="ellipse-outline" *ngIf="pin.length <= 1"></ion-icon>
				<ion-icon name="ellipse" *ngIf="pin.length >= 2"></ion-icon>
				<ion-icon name="ellipse-outline" *ngIf="pin.length <= 2"></ion-icon>
				<ion-icon name="ellipse" *ngIf="pin.length >= 3"></ion-icon>
				<ion-icon name="ellipse-outline" *ngIf="pin.length <= 3"></ion-icon>
				<ion-icon name="ellipse" *ngIf="pin.length == 4"></ion-icon>
			</div>
		</div>

		<div class="numpad">
			<div class="number-row">
				<div class="number field" (click)="add(1)">1</div>
				<div class="number field" (click)="add(2)">2</div>
				<div class="number field" (click)="add(3)">3</div>
			</div>
			<div class="number-row">
				<div class="number field" (click)="add(4)">4</div>
				<div class="number field" (click)="add(5)">5</div>
				<div class="number field" (click)="add(6)">6</div>
			</div>
			<div class="number-row">
				<div class="number field" (click)="add(7)">7</div>
				<div class="number field" (click)="add(8)">8</div>
				<div class="number field" (click)="add(9)">9</div>
			</div>
			<div class="number-row">
				<div class="text field" (click)="clear()" [ngClass]="{ disabled: pin.length <= 0 }">
					{{ "OPERATOR_LOGIN__CLEAR" | transloco }}
				</div>
				<div class="number field" (click)="add(0)">0</div>
				<div class="text field" (click)="delete()" [ngClass]="{ disabled: pin.length <= 0 }">
					{{ "OPERATOR_LOGIN__DELETE" | transloco }}
				</div>
			</div>
		</div>
	</div>
</ng-template>
